export function buildCallerId(): string {
  const prefix = 'front-seller'
  const appBrand = window.env.VUE_APP_CONTEXT // aladin - farmi

  return [prefix, appBrand].filter(Boolean).join('-')
}
